import React, { useEffect } from 'react';
import { useApi } from '@sdir/httpclient/lib/hooks/useApi';
import { useAuthenticatedCheck } from '@sdir/auth/lib/hooks';
import { CertificateV2 } from '@sdir/httpclient/lib/clients/aps/personalcertificate';
import { certificateApi } from '../../../httpclient';
import { CertificateCodesContext } from '../../../services/contexts/CertificateCodesContext';
import { asLoadable } from '../../../types';
import { useCurrentUserInfo } from '../../../services/hooks/useCurrentUserInfo';

type CertificateCodesProviderProps = {
  children?: any;
  currentLanguage?: string;
};

export const CertificateCodesProvider: React.FC<CertificateCodesProviderProps> = ({
  children,
  currentLanguage,
}) => {
  const { isAuthenticated } = useAuthenticatedCheck(false);

  const {
    userInfo: { isOrganization },
  } = useCurrentUserInfo();

  const {
    result: codeResult,
    loading: codeLoading,
    errorObject: codeError,
    callApi: getCertificateCodes,
  } = useApi({
    apiFunction: () => certificateApi.v2CertificateGetcertificatesv2SortByGet(),
  });

  useEffect(() => {
    if (isAuthenticated && !codeLoading && !codeError && !codeResult && !isOrganization) {
      getCertificateCodes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codeLoading, isAuthenticated, isOrganization]);

  useEffect(() => {
    if (isAuthenticated && currentLanguage) {
      setTimeout(() => {
        getCertificateCodes();
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLanguage]);

  const value = asLoadable<CertificateV2[]>(codeResult, codeError, codeLoading);

  return (
    <CertificateCodesContext.Provider value={value}> {children} </CertificateCodesContext.Provider>
  );
};
